module.exports = __webpack_public_path__ + "static/images/logo-armani.0789722b236a5faa18019faec27998b7.png";